
import { AppConfiguration } from '../conf/app.configuration';
import { AuthService } from '../auth.service';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot
} from '../../../node_modules/@angular/router';
import { Store } from '../../../node_modules/@ngrx/store';
import { AppState } from '../store/AppState';
import { UserService } from '../user.service';
import { ProfileGuard } from './profile-guard.service';
import { DossierService } from '../dossiers/dossier.service';
import { map, flatMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class FEGuard extends ProfileGuard {
  /*

  constructor(
    private userService: UserService,
    appConfig: AppConfiguration,
    auth: AuthService,
    router: Router,
    store: Store<AppState>


  */
  constructor(
    userService: UserService,
    appConfig: AppConfiguration,
    auth: AuthService,
    router: Router,
    store: Store<AppState>,
    private dossierService: DossierService,
  ) {
    super(userService, appConfig, auth, router, store);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return super.canActivate(route, state).pipe(
      flatMap(
        (canActivate: boolean) => {
          if (canActivate) {
            // si se intenta navegar a un expeidente concreto
            if (route.url[1]) {
              return this.dossierService.canAccess(route.url[1]['path']).pipe(
                map(
                  (can: boolean) => {
                    if (!can) {
                      console.error('El expediente no está en un estado que permita ser editado');
                      this.router.navigate(['accesoDenegado']);
                    }
                    return can;
                  }));
            } else {
              // acceso a la ficha para crear nuevo expediente
              return of(true);
            }
          }
          return of(canActivate);
        })
    )

  }
}
